function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function ArrowUp({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.053 6.5a1 1 0 01.706.295l8.95 9a1 1 0 01-1.418 1.41l-8.245-8.29-8.34 8.294a1 1 0 11-1.411-1.418l9.05-9a1 1 0 01.708-.291z",
    fill: props.color || "#222"
  }));
}

const MemoArrowUp = React.memo(ArrowUp);
export default MemoArrowUp;